import React from "react";
import { Container } from "reactstrap";

import "./Layout/layout.css";

const Layout = props => {
  return (
    <Container className="App" fluid={true}>
      {props.children}
    </Container>
  );
};

export default Layout;
